// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3i9vx","title":"ClientCherryInfo_title__1vIkX","itemText":"ClientCherryInfo_itemText__142lE"};